/* GRYPWRK — pack selector, box contents, gallery */
(function () {
  var initialVariant = new URLSearchParams(window.location.search).get('variant');

  // Liefertermin: konkrete Daten statt « 6–8 Werktage » (Wochenenden übersprungen)
  document.querySelectorAll('[data-gs-eta]').forEach(function (el) {
    var add = function (n) {
      var d = new Date(); d.setHours(12, 0, 0, 0);
      while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
      return d;
    };
    var fmt = function (d) {
      return ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'][d.getDay()] + ' ' + ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.';
    };
    var a = parseInt(el.dataset.min, 10), b = parseInt(el.dataset.max, 10);
    if (a > 0 && b >= a) el.innerHTML = 'Lieferung zwischen <strong>' + fmt(add(a)) + '</strong> und <strong>' + fmt(add(b)) + '</strong>';
  });
  document.querySelectorAll('[data-gs-product]').forEach(function (root) {
    var radios = root.querySelectorAll('[data-gs-variant]');
    var idInput = root.querySelector('input[name="id"]');
    var submit = root.querySelector('.product-form__submit');
    var rings = root.querySelectorAll('[data-gs-ring]');
    var count = root.querySelector('[data-gs-ring-count]');
    var range = root.querySelector('[data-gs-ring-range]');
    var slides = root.querySelectorAll('.gs-gallery__slide');
    var thumbs = root.querySelectorAll('.gs-gallery__thumb');

    function showMedia(id) {
      if (!id) return;
      var found = false;
      slides.forEach(function (s) { var on = s.dataset.mediaId === String(id); s.classList.toggle('is-active', on); if (on) found = true; });
      if (!found) return;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === String(id)); });
      var active = root.querySelector('.gs-gallery__thumb.is-active');
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }

    function apply(radio) {
      if (!radio) return;
      if (idInput && !radio.external) {
        idInput.value = radio.value;
        idInput.disabled = radio.hasAttribute('data-unavailable');
      }
      if (submit && !radio.external) submit.disabled = radio.hasAttribute('data-unavailable');
      var key = radio.dataset.packsKey;
      var n = 0, min = Infinity, max = -Infinity;
      rings.forEach(function (r) {
        var packs = (r.dataset.packs || '').split('|');
        var on = !key || packs.indexOf(key) !== -1;
        r.hidden = !on;
        if (on) {
          n++;
          var a = parseFloat(r.dataset.kgMin), b = parseFloat(r.dataset.kgMax);
          if (!isNaN(a)) min = Math.min(min, a);
          if (!isNaN(b)) max = Math.max(max, b);
        }
      });
      if (count) count.textContent = n;
      if (range) range.textContent = isFinite(min) && isFinite(max) ? min + '–' + max + ' kg' : '—';
      if (!radio.noMedia) showMedia(radio.dataset.mediaId);
      // keep URL in sync so refresh/share keeps the pack (not with Moon Bundles: it reads ?variant= itself)
      if (!radio.external) try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    }

    radios.forEach(function (r) { r.addEventListener('change', function () { apply(r); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.mediaId); }); });

    // Sélecteur externe (Moon Bundles) : suivre la variante choisie dans le formulaire
    var mapEl = root.querySelector('[data-gs-variants]');
    if (!radios.length && mapEl && idInput) {
      var map = {};
      try { map = JSON.parse(mapEl.textContent); } catch (e) {}
      var keys = Object.keys(map);
      var moonSelected = function () {
        var opts = document.querySelectorAll('.moonbundle-option-wrapper');
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].querySelector('.moonbundle-option-active') || opts[i].classList.contains('moonbundle-option-active')) return keys[i] || '';
        }
        return '';
      };
      var form = idInput.form, last = null, acted = false;
      var sync = function () {
        var el = form ? form.querySelector('input[name="id"]') : idInput;
        var v = moonSelected() || (el ? String(el.value) : '');
        if (!v || v === last || !map[v]) return;
        last = v;
        var m = map[v];
        apply({ value: v, dataset: { packsKey: m.key, mediaId: m.media }, hasAttribute: function () { return false; }, external: true, noMedia: !acted });
        // bouton d'achat précis : « Gesellen-Set holen · 69,99 € »
        var lbl = submit && submit.querySelector('span');
        if (lbl && m.title && m.price && m.available !== false) lbl.textContent = m.title + ' holen · ' + m.price;
      };
      if (form) { form.addEventListener('change', sync, true); form.addEventListener('input', sync, true); }
      // la galerie ne bascule sur l'image du set qu'après un vrai choix du client (la vidéo reste en tête au chargement)
      document.addEventListener('click', function (e) {
        if (e.isTrusted && e.target.closest && e.target.closest('moonbundle-component, .moonbundle-box')) acted = true;
        setTimeout(sync, 60);
      }, true);
      setInterval(sync, 500);
      sync();

      // Prix par ring sous chaque offre Moon (sauf si l'offre affiche déjà « pro Ring »)
      var ringsFor = function (key) {
        var n = 0;
        rings.forEach(function (r) { if ((r.dataset.packs || '').split('|').indexOf(key) !== -1) n++; });
        return n;
      };
      var perRing = function (txt, n) {
        var m = txt.match(/\d{1,3}(?:[.\s ]\d{3})*[.,]\d{2}|\d+[.,]\d{2}|\d+/);
        if (!m || !n) return null;
        var raw = m[0], dec = /,\d{2}$/.test(raw) ? ',' : '.';
        var num = parseFloat(dec === ',' ? raw.replace(/[.\s ]/g, '').replace(',', '.') : raw.replace(/[,\s ]/g, ''));
        if (!num) return null;
        var v = (Math.round(Math.round(num * 100) / n) / 100).toFixed(2);
        return txt.replace(raw, dec === ',' ? v.replace('.', ',') : v);
      };
      var leaf = function (root, test) {
        var out = null;
        root.querySelectorAll('*').forEach(function (e) {
          if (!out && e.children.length === 0 && test((e.textContent || '').trim())) out = e;
        });
        return out;
      };
      var addPerRing = function () {
        document.querySelectorAll('.moonbundle-option-wrapper').forEach(function (w, i) {
          if (w.querySelector('.gs-per-ring') || /pro Ring/i.test(w.textContent)) return;
          var n = keys[i] ? ringsFor(map[keys[i]].key) : 0;
          var priceEl = leaf(w, function (s) { return /^(?:[^\d\s]{0,4}\s?)\d[\d.,\s ]*(?:\s?[^\d\s]{0,4})$/.test(s) && /[.,]\d{2}/.test(s); });
          var subEl = leaf(w, function (s) { return /Ringe/.test(s); });
          var pr = priceEl && perRing(priceEl.textContent.trim(), n);
          if (!pr || !subEl) return;
          var span = document.createElement('span');
          span.className = 'gs-per-ring';
          span.textContent = pr + ' pro Ring';
          subEl.appendChild(span);
        });
      };
      var tries2 = 0, per = setInterval(function () {
        addPerRing();
        if (++tries2 > 40) clearInterval(per);
      }, 250);
      var queued = false;
      new MutationObserver(function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; addPerRing(); }); }).observe(document.body, { childList: true, subtree: true });
      // lien ?variant= (cartes de l'accueil) : sélectionner l'offre Moon correspondante une fois le widget rendu
      var wanted = initialVariant ? Object.keys(map).indexOf(initialVariant) : -1;
      if (wanted > -1) {
        var tries = 0, pick = setInterval(function () {
          var opts = document.querySelectorAll('.moonbundle-option-wrapper');
          if (opts.length > wanted) {
            clearInterval(pick);
            var opt = opts[wanted].querySelector('.moonbundle-option') || opts[wanted];
            if (!opt.classList.contains('moonbundle-option-active')) opt.click();
          } else if (++tries > 40) clearInterval(pick);
        }, 150);
      }
      return;
    }

    var checked = root.querySelector('[data-gs-variant]:checked');
    if (checked) apply(checked); else if (rings.length) apply({ value: idInput ? idInput.value : '', dataset: {}, hasAttribute: function () { return false; } });
  });
})();
